module.exports = __webpack_public_path__ + "media/images/award-badges-mobile-pt-962e427485a9b1d3c418dc8154dba472.svg";